import { Box, Typography } from "@mui/material";
import { ContestWithId } from "../../interfaces/IContests";
import { Event } from "@mui/icons-material";
import { formatDateTime } from "../../utils/dates";

interface ContestRegistrationSectionProps {
  contest?: ContestWithId;
}

export default function ContestRegistrationSection({ contest }: ContestRegistrationSectionProps) {
  const isRegistrationOpen =
    contest?.registrationEnd && new Date() <= new Date(contest.registrationEnd);

  const getLabel = () => {
    if (!contest?.registrationEnd) return "Rejestracja:";
    return isRegistrationOpen ? "Rejestracja otwarta do:" : "Termin rejestracji upłynął:";
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      <Event sx={{ fontSize: 16, color: "#6c6c6c" }} />
      <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.8rem" }}>
        {getLabel()}
      </Typography>
      <Typography variant="body2" sx={{ fontWeight: 500, fontSize: "0.8rem" }}>
        {contest?.registrationEnd ? formatDateTime(contest.registrationEnd) : "Brak"}
      </Typography>
    </Box>
  );
}
